module.exports = __webpack_public_path__ + "img/proyecto_3.c5e67761.png";